export const GENERAL_TABLE_FIRST_COL_REQUEST = 'GENERAL_TABLE_FIRST_COL_REQUEST';
export const GENERAL_TABLE_FIRST_COL_SUCCESS = 'GENERAL_TABLE_FIRST_COL_SUCCESS';
export const GENERAL_TABLE_FIRST_COL_FAIL = 'GENERAL_TABLE_FIRST_COL_FAIL';